import React from 'react'
import './NavBar.css'
import vw from '../assets/redesignLogo2.jpg'
import { RiLoginCircleFill } from "react-icons/ri";
import { Link } from 'react-router-dom';

const NavBar = () => {
  return (
    <div className='parentContainer'>
      <div className='lowerNavEle'>
        
          <img src={vw} className='adjustLogo' alt='' />
       
        <ul>
          <a href='https://www.vitelwireless.com/data-plan' target='blank' style={{color:"white"}}>  Vitel Data </a> 
        
          <li> <a href='https://www.vitelwireless.com/data-plan' target='blank' style={{color:"white"}}> Voice Plan </a>   </li>
          
          <li > <a href='https://www.vitelwireless.com/about-us' target='blank' style={{color:"white"}}>About Us </a> </li>
        </ul>
        <ul className='search'>
          <li>
            <Link to='/login' className='Loginlink'>
              Login <RiLoginCircleFill />{" "}
            </Link>
          </li>
        </ul>
      </div>
    </div>
  );
}

export default NavBar